import { TextBlock } from './TextBlock';
import { ThinkingBlock } from './ThinkingBlock';
import { RedactedThinkingBlock } from './RedactedThinkingBlock';
import { DisplayOnlyBlock } from './DisplayOnlyBlock';
import { ImageBlock } from './ImageBlock';
import { FileBlock } from './FileBlock';
import { FileReferencesBlock } from './FileReferencesBlock';
import { SkillAccessDeniedBlock } from './SkillAccessDeniedBlock';
import { InlineDisplayBlock } from './InlineDisplayBlock';
import { ArtifactBlock } from './ArtifactBlock';
import { ToolBlockRenderer } from './ToolBlockRenderer';
import { FallbackBlock } from './FallbackBlock';
export const defaultRenderers = {
  TEXT: TextBlock,
  THINKING: ThinkingBlock,
  REDACTED_THINKING: RedactedThinkingBlock,
  // normalizeMessages drops CONTEXT blocks before they reach the renderer.
  // This null renderer prevents FallbackBlock from exposing raw JSON if a
  // CONTEXT block reaches the renderer through a manually-constructed message.
  CONTEXT: function ContextHidden() {
    return null;
  },
  DISPLAY_ONLY: DisplayOnlyBlock,
  IMAGE: ImageBlock,
  PDF: FileBlock,
  FILE: FileBlock,
  FILE_REFERENCES: FileReferencesBlock,
  SKILL_ACCESS_DENIED: SkillAccessDeniedBlock,
  INLINE_DISPLAY: InlineDisplayBlock,
  ARTIFACT: ArtifactBlock,
  TOOL: ToolBlockRenderer
};
export { createBlockRenderer } from '../createBlockRenderer';
export { FallbackBlock };
export { ArtifactBlock } from './ArtifactBlock';